"use client";

import { useTranslation } from "react-i18next";

function formatCurrency(value: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export type ExceededCreditsCardModalCompanyPlanProps = {
  planName?: string;
  totalCredits: number;
  creditUnitPrice: number;
  totalValue: number;
  packageId?: number;
};

export function ExceededCreditsCardModalCompanyPlan({
  planName,
  totalCredits,
  creditUnitPrice,
  totalValue,
  packageId,
}: ExceededCreditsCardModalCompanyPlanProps) {
  const { t } = useTranslation(["dashboard"]);

  return (
    <div>
      <h4 className="text-lg text-neutral-900 mb-3">
        {t("exceeded-credits-modal-overview", "Visão geral")}
      </h4>
      <div className="rounded-lg bg-white shadow-lg shadow-[#854d0e08]">
        <div className="p-3 border-b border-lightgray-400">
          <p className="text-sm text-foreground">
            {planName ?? t("exceeded-credits-modal-plan", "Plano atual")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 p-6">
          <div className="rounded-lg border border-lightgray-400 bg-white p-2 flex flex-col items-center justify-center text-center min-h-[72px]">
            <p className="text-[12px] text-muted-foreground mb-1">
              {t("exceeded-credits-modal-credit-package", "Pacote de créditos")}
            </p>
            <p className="text-base font-medium text-darkgray-900">
              {totalCredits.toLocaleString("pt-BR")}
            </p>
          </div>
          <div className="rounded-lg border border-lightgray-400 bg-white p-3 flex flex-col items-center justify-center text-center min-h-[72px]">
            <p className="text-[12px] text-muted-foreground mb-1">
              {t("exceeded-credits-modal-credit-value", "Valor do crédito")}
            </p>
            <p className="text-base font-medium text-darkgray-900">
              {formatCurrency(creditUnitPrice)}
            </p>
          </div>
          <div className="rounded-lg border border-lightgray-400 bg-white p-3 flex flex-col items-center justify-center text-center min-h-[72px]">
            <p className="text-[12px] text-muted-foreground mb-1">
              {t("exceeded-credits-modal-investment", "Investimento")}
            </p>
            <p className="text-base font-medium text-darkgray-900">
              {formatCurrency(totalValue)}
            </p>
          </div>
          <div className="rounded-lg border border-lightgray-400 bg-white p-3 flex flex-col items-center justify-center text-center min-h-[72px]">
            <p className="text-[12px] text-muted-foreground mb-1">
              {t("exceeded-credits-modal-package", "Pacote")}
            </p>
            <p className="text-base font-medium text-darkgray-900">
              {packageId != null ? String(packageId) : "—"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
